(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/top-header.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/top-header.js');
'use strict';

const {
  BigIcon,
  TopTitle
} = svs.myProfile.react.shared.components;

const TopHeader = _ref => {
  let {
    title,
    icon
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(BigIcon, {
    icon: icon
  }), React.createElement(TopTitle, null, title));
};
svs.myProfile.react.shared.components.TopHeader = TopHeader;

 })(window);